import { useState } from 'react';

interface Modulo {
  num: string;
  title: string;
  objetivo: string;
  conteudo: string[];
  ferramentas: string[];
  entregavel: string;
  color: string;
  light: string;
  border: string;
  text: string;
  icon: string;
  img: string;
  bonus?: boolean;
}

const modulos: Modulo[] = [
  {
    num: '01',
    title: 'Mapa de Gargalos e Alavancas',
    objetivo: 'Identificar onde o negócio está travado e onde pode crescer mais rápido.',
    conteudo: [
      'Diagnóstico estrutural do negócio',
      'Análise de mercado e concorrência',
      'Identificação de gargalos operacionais',
      'Identificação de oportunidades de crescimento',
      'Definição de metas estratégicas',
    ],
    ferramentas: ['Matriz de gargalos', 'Mapa de alavancas', 'Diagnóstico de maturidade empresarial'],
    entregavel: 'Raio-X completo da empresa',
    color: 'bg-violet-600',
    light: 'bg-violet-50',
    border: 'border-violet-200',
    text: 'text-violet-600',
    icon: 'ri-map-2-line',
    img: 'https://readdy.ai/api/search-image?query=magnifying%20glass%20held%20over%20a%20large%20vintage%20treasure%20map%20with%20red%20X%20marks%20bottleneck%20zones%20and%20dotted%20route%20paths%20drawn%20in%20ink%2C%20compass%20rose%20in%20corner%2C%20aged%20parchment%20paper%20texture%20on%20wooden%20table%2C%20warm%20golden%20overhead%20light%2C%20discovery%20and%20diagnosis%20concept%2C%20sharp%20detail%20top%20view&width=400&height=220&seq=xmap_bottleneck_treasure_77341&orientation=landscape',
  },
  {
    num: '02',
    title: 'Gestão e Estrutura Operacional',
    objetivo: 'Organizar o funcionamento da empresa com processos e rotinas claras.',
    conteudo: [
      'Definição de estrutura organizacional',
      'Mapeamento de processos',
      'Criação de rotinas operacionais',
      'Criação de indicadores de gestão',
      'Gestão por metas',
    ],
    ferramentas: ['Organograma funcional', 'Mapa de processos', 'Painel de indicadores', 'B.I com indicadores'],
    entregavel: 'Estrutura organizacional clara e processos definidos',
    color: 'bg-sky-600',
    light: 'bg-sky-50',
    border: 'border-sky-200',
    text: 'text-sky-600',
    icon: 'ri-building-2-line',
    img: 'https://readdy.ai/api/search-image?query=architect%20blueprint%20technical%20drawing%20of%20building%20floor%20plan%20with%20structural%20grid%20lines%20rooms%20and%20labeled%20sections%20spread%20on%20drafting%20table%2C%20precision%20ruler%20and%20pencil%20on%20top%2C%20engineering%20and%20planning%20concept%2C%20cool%20blue%20toned%20studio%20lighting%2C%20professional%20technical%20photography&width=400&height=220&seq=blueprint_structure_org_88452&orientation=landscape',
  },
  {
    num: '03',
    title: 'Organização Financeira',
    objetivo: 'Criar controle real sobre o dinheiro do negócio.',
    conteudo: [
      'Estruturação do fluxo de caixa',
      'DRE simplificado',
      'Controle de custos',
      'Margem de contribuição',
      'Ponto de equilíbrio',
      'Formação de preço correta',
    ],
    ferramentas: ['Planilha financeira estruturada', 'Dashboard financeiro', 'Assistentes Financeiros com IA'],
    entregavel: 'Planejamento Financeiro',
    color: 'bg-emerald-600',
    light: 'bg-emerald-50',
    border: 'border-emerald-200',
    text: 'text-emerald-600',
    icon: 'ri-money-dollar-circle-line',
    img: 'https://readdy.ai/api/search-image?query=stack%20of%20Brazilian%20real%20banknotes%20fanned%20out%20beside%20a%20glass%20jar%20with%20coins%20overflowing%2C%20green%20bar%20chart%20printed%20on%20paper%20showing%20profit%20growth%2C%20calculator%20and%20pen%20on%20white%20marble%20surface%2C%20clean%20minimal%20financial%20abundance%20concept%2C%20bright%20natural%20daylight%2C%20sharp%20close%20up%20photography&width=400&height=220&seq=money_coins_finance_green_55219&orientation=landscape',
  },
  {
    num: '04',
    title: 'Estrutura Comercial',
    objetivo: 'Transformar um comercial improvisado em uma operação com processo, rotina e previsibilidade de vendas.',
    conteudo: [
      'Funil comercial adaptado à sua operação',
      'Organização e qualificação de leads',
      'Processo de atendimento e avanço de oportunidades',
      'Scripts para abordagem, follow-up e fechamento',
      'Métricas para acompanhar conversão e performance',
      'Etapas de fechamento com mais controle e previsibilidade',
    ],
    ferramentas: ['CRM simplificado', 'Scripts de vendas', 'Painel de conversão'],
    entregavel: 'Plano prático da sua estrutura comercial',
    color: 'bg-orange-600',
    light: 'bg-orange-50',
    border: 'border-orange-200',
    text: 'text-orange-600',
    icon: 'ri-bar-chart-grouped-line',
    img: 'https://readdy.ai/api/search-image?query=large%20orange%20sales%20funnel%20shape%20made%20of%20paper%20cutout%20on%20white%20desk%20with%20small%20figurines%20of%20people%20entering%20the%20top%20and%20a%20single%20gold%20coin%20at%20the%20bottom%20exit%2C%20conversion%20and%20pipeline%20concept%2C%20bold%20graphic%20minimal%20style%2C%20bright%20studio%20lighting%2C%20creative%20business%20concept%20photography&width=400&height=220&seq=funnel_sales_orange_pipeline_66830&orientation=landscape',
  },
  {
    num: '05',
    title: 'Inovação e Eficiência Empresarial',
    objetivo: 'Identificar novas oportunidades de crescimento e diferenciação competitiva.',
    conteudo: [
      'Revisão do modelo de negócio',
      'Identificação de diferenciação competitiva',
      'Desenvolvimento de novos produtos ou serviços',
      'Estratégias de expansão',
    ],
    ferramentas: ['Canvas de modelo de negócio', 'Mapa de diferenciação', 'Plano de expansão'],
    entregavel: 'Plano de Implementação de Inovação',
    color: 'bg-teal-600',
    light: 'bg-teal-50',
    border: 'border-teal-200',
    text: 'text-teal-600',
    icon: 'ri-lightbulb-flash-line',
    img: 'https://readdy.ai/api/search-image?query=glowing%20Edison%20light%20bulb%20lying%20on%20its%20side%20on%20a%20wooden%20surface%20surrounded%20by%20scattered%20gears%20cogs%20and%20small%20green%20plant%20sprouts%20growing%20from%20soil%2C%20innovation%20and%20growth%20metaphor%2C%20teal%20and%20warm%20tones%2C%20shallow%20depth%20of%20field%2C%20creative%20concept%20still%20life%20photography&width=400&height=220&seq=lightbulb_gears_innovation_teal_44107&orientation=landscape',
  },
  {
    num: '06',
    title: 'Inteligência Artificial Aplicada ao Negócio',
    objetivo: 'Aumentar produtividade e eficiência com ferramentas de IA.',
    conteudo: [
      'Uso de IA no atendimento ao cliente',
      'Geração automática de conteúdos',
      'Análise de dados com IA',
      'Automação de tarefas operacionais',
      'Criação de assistentes empresariais',
    ],
    ferramentas: ['Ferramentas de IA selecionadas', 'Assistentes automatizados', 'Fluxos de automação'],
    entregavel: 'Ferramentas de IA implementadas',
    color: 'bg-rose-600',
    light: 'bg-rose-50',
    border: 'border-rose-200',
    text: 'text-rose-600',
    icon: 'ri-robot-line',
    img: 'https://readdy.ai/api/search-image?query=humanoid%20robot%20hand%20reaching%20toward%20a%20floating%20holographic%20brain%20made%20of%20glowing%20neural%20network%20nodes%20and%20data%20connections%2C%20dark%20background%20with%20rose%20pink%20and%20white%20light%20particles%2C%20futuristic%20artificial%20intelligence%20concept%2C%20cinematic%20sci-fi%20photography%2C%20dramatic%20lighting&width=400&height=220&seq=robot_brain_ai_neural_rose_33698&orientation=landscape',
  },
  {
    num: '07',
    title: 'Jurídico para Empresas',
    objetivo: 'Demonstrar como a empresa pode reduzir falhas, acelerar processos e proteger suas relações com apoio de uma estrutura jurídica inteligente.',
    conteudo: [
      'Onde as empresas mais erram na formalização de relações',
      'Contratos e documentos feitos de forma improvisada',
      'O custo invisível da desorganização jurídica',
      'Riscos de depender de documentos soltos, versões antigas e processos manuais',
      'Como padronizar documentos sem perder segurança jurídica',
      'O papel da tecnologia na rotina contratual da empresa',
    ],
    ferramentas: ['Biblioteca de documentos jurídicos', 'Padronização contratual estratégica', 'Plataforma jurídica empresarial'],
    entregavel: 'Mapa de eficiência jurídica para reduzir riscos, ganhar produtividade e melhorar a operação',
    color: 'bg-indigo-700',
    light: 'bg-indigo-50',
    border: 'border-indigo-200',
    text: 'text-indigo-700',
    icon: 'ri-scales-3-line',
    img: 'https://readdy.ai/api/search-image?query=elegant%20law%20office%20desk%20with%20open%20legal%20books%2C%20a%20wooden%20gavel%20resting%20beside%20neatly%20stacked%20contract%20documents%20and%20a%20fountain%20pen%2C%20warm%20golden%20lamp%20light%20casting%20soft%20shadows%2C%20dark%20wood%20and%20leather%20textures%2C%20professional%20legal%20business%20concept%2C%20sophisticated%20and%20clean%20composition%2C%20close%20up%20photography&width=400&height=220&seq=law_gavel_contracts_legal_office_91204&orientation=landscape',
    bonus: true,
  },
];

function CardNormal({ mod }: { mod: Modulo }) {
  return (
    <div className={`rounded-3xl border-2 ${mod.border} ${mod.light} p-6 md:p-10 lg:p-12`}>
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 md:gap-10">
        {/* Left */}
        <div className="lg:col-span-1 flex flex-col">
          <div className={`w-14 h-14 md:w-18 md:h-18 flex items-center justify-center rounded-2xl ${mod.color} mb-5`}>
            <i className={`${mod.icon} text-white text-2xl md:text-3xl`} />
          </div>
          <div className={`text-6xl md:text-7xl font-black ${mod.text} opacity-15 mb-2 leading-none`}>{mod.num}</div>
          <h3 className="text-2xl md:text-3xl font-black text-gray-900 mb-4 leading-tight">{mod.title}</h3>
          <p className="text-gray-500 text-sm leading-relaxed mb-6">
            <strong className="text-gray-700">Objetivo:</strong> {mod.objetivo}
          </p>
          {/* Entregável */}
          <div className={`rounded-2xl p-5 border-2 ${mod.border} mt-auto bg-gradient-to-br from-white to-${mod.light.split('-')[1]}-50`}>
            <div className="flex items-center gap-2 mb-3">
              <div className={`w-8 h-8 flex items-center justify-center rounded-xl ${mod.color}`}>
                <i className="ri-gift-2-line text-white text-base" />
              </div>
              <span className={`text-xs font-black uppercase tracking-widest ${mod.text}`}>Entregável</span>
            </div>
            <p className={`text-gray-800 text-sm font-bold leading-snug ${mod.text}`}>{mod.entregavel}</p>
          </div>
        </div>

        {/* Right */}
        <div className="lg:col-span-2 grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6">
          {/* Conteúdo */}
          <div className="bg-white rounded-2xl p-6 md:p-7 border border-stone-100">
            <h4 className="text-xs font-black uppercase tracking-widest text-amber-500 mb-5">Conteúdo do Módulo</h4>
            <ul className="space-y-3">
              {mod.conteudo.map((item) => (
                <li key={item} className="flex items-start gap-3">
                  <span className={`w-5 h-5 flex items-center justify-center rounded-full ${mod.color} shrink-0 mt-0.5`}>
                    <i className="ri-check-line text-white text-xs" />
                  </span>
                  <span className="text-gray-700 text-sm leading-relaxed">{item}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* Ferramentas + Imagem */}
          <div className="flex flex-col gap-5 md:gap-6">
            <div className="bg-white rounded-2xl p-6 md:p-7 border border-stone-100">
              <h4 className="text-xs font-black uppercase tracking-widest text-amber-500 mb-5">Ferramentas Utilizadas pelo Facilitador</h4>
              <ul className="space-y-3">
                {mod.ferramentas.map((f) => (
                  <li key={f} className="flex items-center gap-3">
                    <i className={`${mod.icon} text-gray-400 text-sm`} />
                    <span className="text-gray-700 text-sm">{f}</span>
                  </li>
                ))}
              </ul>
            </div>
            <div className="rounded-2xl overflow-hidden flex-1 min-h-[160px] md:min-h-[180px]">
              <img
                key={mod.num}
                src={mod.img}
                alt={`Módulo ${mod.num} — ${mod.title}`}
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

function CardBonus({ mod }: { mod: Modulo }) {
  return (
    <div className="relative rounded-3xl overflow-hidden">
      {/* Fundo escuro premium */}
      <div className="absolute inset-0 bg-gradient-to-br from-gray-950 via-indigo-950 to-gray-950" />
      {/* Borda dourada animada */}
      <div className="absolute inset-0 rounded-3xl" style={{ padding: 2, background: 'linear-gradient(135deg, #f59e0b, #6366f1, #f59e0b)', WebkitMask: 'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)', WebkitMaskComposite: 'xor', maskComposite: 'exclude' }} />
      {/* Brilho de fundo */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[600px] h-[300px] bg-indigo-500/10 rounded-full blur-3xl pointer-events-none" />
      <div className="absolute bottom-0 right-0 w-[400px] h-[300px] bg-amber-500/8 rounded-full blur-3xl pointer-events-none" />

      {/* Badge topo centralizado */}
      <div className="relative z-10 flex justify-center pt-6">
        <div className="inline-flex items-center gap-2 bg-gradient-to-r from-amber-400 to-amber-500 text-gray-950 text-xs font-black px-5 py-2 rounded-full tracking-widest uppercase">
          <i className="ri-gift-2-line text-sm" />
          MÓDULO BÔNUS EXCLUSIVO
          <i className="ri-gift-2-line text-sm" />
        </div>
      </div>

      <div className="relative z-10 p-6 md:p-10 lg:p-12 pt-6">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 md:gap-10">
          {/* Left */}
          <div className="lg:col-span-1 flex flex-col">
            <div className="w-14 h-14 md:w-18 md:h-18 flex items-center justify-center rounded-2xl bg-gradient-to-br from-amber-400 to-amber-600 mb-5">
              <i className={`${mod.icon} text-white text-2xl md:text-3xl`} />
            </div>
            <div className="text-6xl md:text-7xl font-black text-amber-400/20 mb-2 leading-none">{mod.num}</div>
            <h3 className="text-2xl md:text-3xl font-black text-white mb-4 leading-tight">{mod.title}</h3>
            <p className="text-white/50 text-sm leading-relaxed mb-6">
              <strong className="text-amber-400">Objetivo:</strong> {mod.objetivo}
            </p>

            {/* Entregável */}
            <div className="bg-gradient-to-br from-amber-500/10 to-indigo-500/10 border-2 border-amber-400/40 rounded-2xl p-5 mt-auto">
              <div className="flex items-center gap-2 mb-3">
                <div className="w-8 h-8 flex items-center justify-center rounded-xl bg-gradient-to-br from-amber-400 to-amber-600">
                  <i className="ri-gift-2-line text-white text-base" />
                </div>
                <span className="text-xs font-black uppercase tracking-widest text-amber-400">Entregável</span>
              </div>
              <p className="text-white font-bold text-sm leading-snug">{mod.entregavel}</p>
            </div>
          </div>

          {/* Right */}
          <div className="lg:col-span-2 grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6">
            {/* Conteúdo */}
            <div className="bg-white/5 border border-white/10 rounded-2xl p-6 md:p-7">
              <h4 className="text-xs font-black uppercase tracking-widest text-amber-400 mb-5">Conteúdo do Módulo</h4>
              <ul className="space-y-3">
                {mod.conteudo.map((item) => (
                  <li key={item} className="flex items-start gap-3">
                    <span className="w-5 h-5 flex items-center justify-center rounded-full bg-amber-500 shrink-0 mt-0.5">
                      <i className="ri-check-line text-white text-xs" />
                    </span>
                    <span className="text-white/70 text-sm leading-relaxed">{item}</span>
                  </li>
                ))}
              </ul>
            </div>

            {/* Ferramentas + Imagem */}
            <div className="flex flex-col gap-5 md:gap-6">
              <div className="bg-white/5 border border-white/10 rounded-2xl p-6 md:p-7">
                <h4 className="text-xs font-black uppercase tracking-widest text-amber-400 mb-5">Ferramentas Utilizadas pelo Facilitador</h4>
                <ul className="space-y-3">
                  {mod.ferramentas.map((f) => (
                    <li key={f} className="flex items-center gap-3">
                      <i className="ri-tools-line text-amber-400/60 text-sm" />
                      <span className="text-white/70 text-sm">{f}</span>
                    </li>
                  ))}
                </ul>
              </div>
              <div className="rounded-2xl overflow-hidden flex-1 min-h-[160px] md:min-h-[180px] relative">
                <img
                  key={mod.num}
                  src={mod.img}
                  alt={`Módulo ${mod.num} — ${mod.title}`}
                  className="w-full h-full object-cover object-top"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-indigo-950/60 to-transparent" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default function ModulosSection() {
  const [activeModulo, setActiveModulo] = useState(0);
  const mod = modulos[activeModulo];

  return (
    <section id="modulos" className="py-24 md:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        {/* Header */}
        <div className="text-center mb-16">
          <p className="text-xs font-semibold tracking-[0.25em] uppercase text-stone-400 mb-4">
            Conteúdo do programa
          </p>
          <h2 className="text-4xl md:text-6xl font-black text-gray-900 leading-tight mb-4">
            6 MÓDULOS + 1 BÔNUS DE<br />
            <span className="text-amber-500">TRANSFORMAÇÃO COMPLETA</span>
          </h2>
          <p className="text-gray-500 text-lg max-w-xl mx-auto">
            Cada módulo é aplicado diretamente no seu negócio.<br />
            30% conteúdo, 70% prática
          </p>
        </div>

        {/* Tab selector — grid 2 cols no mobile, pills no desktop */}
        <div className="grid grid-cols-2 gap-2 sm:flex sm:flex-wrap sm:justify-center sm:gap-3 mb-12">
          {modulos.map((m, i) => (
            <button
              key={m.num}
              onClick={() => setActiveModulo(i)}
              className={`flex items-center gap-2.5 px-4 py-3.5 sm:py-2.5 sm:px-5 rounded-2xl sm:rounded-full text-xs sm:text-sm font-semibold transition-all cursor-pointer border w-full sm:w-auto ${
                activeModulo === i
                  ? m.bonus
                    ? 'bg-gradient-to-r from-amber-500 to-indigo-600 text-white border-transparent'
                    : `${m.color} text-white border-transparent`
                  : m.bonus
                  ? 'bg-indigo-50 text-indigo-600 border-indigo-200 hover:border-indigo-400'
                  : 'bg-stone-50 text-gray-600 border-stone-200 hover:border-stone-300'
              }`}
            >
              {/* Ícone + número no mobile */}
              <div className={`w-7 h-7 flex items-center justify-center rounded-lg flex-shrink-0 sm:hidden ${activeModulo === i ? 'bg-white/20' : m.bonus ? 'bg-indigo-100' : 'bg-stone-200'}`}>
                <i className={`${m.icon} text-sm ${activeModulo === i ? 'text-white' : m.bonus ? 'text-indigo-600' : 'text-gray-500'}`} />
              </div>
              <div className="flex flex-col items-start sm:hidden min-w-0">
                <span className={`text-[10px] font-black tracking-widest ${activeModulo === i ? 'text-white/70' : 'text-gray-400'}`}>{m.num}</span>
                <span className="text-xs font-bold leading-tight line-clamp-2 text-left">{m.title}</span>
              </div>
              {/* Desktop: número + título inline */}
              <span className="hidden sm:block font-black">{m.num}</span>
              <span className="hidden sm:inline-flex items-center gap-1.5">{m.title}</span>
              {m.bonus && (
                <span className={`hidden sm:inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[10px] font-black tracking-wide ${activeModulo === i ? 'bg-white/20 text-white' : 'bg-amber-100 text-amber-700'}`}>
                  <i className="ri-gift-line" />
                  BÔNUS
                </span>
              )}
              {/* Badge bônus no mobile */}
              {m.bonus && (
                <span className={`sm:hidden ml-auto flex-shrink-0 text-[9px] font-black px-1.5 py-0.5 rounded-full ${activeModulo === i ? 'bg-white/20 text-white' : 'bg-amber-100 text-amber-700'}`}>
                  BÔNUS
                </span>
              )}
            </button>
          ))}
        </div>

        {/* Active module content */}
        {mod.bonus ? <CardBonus mod={mod} /> : <CardNormal mod={mod} />}
      </div>
    </section>
  );
}
